export function login(token: string) {
  try {
    sessionStorage.setItem('@cms/token', token);
  } catch (e) {}
}

export function logout() {
  try {
    sessionStorage.removeItem('@cms/token');
  } catch (e) {}
}

export function getCookie() {
  try {
    return sessionStorage.getItem('@cms/token');
  } catch (e) {}
}
